import {BootstrapTooltip} from '../../AutoProjectImageCollectionTab/Style/AutoProjectImageCollectionTab.style';
import {CheckIcon, Box} from '../../../ui-library';
import React from 'react';
import useRandomSamplerDropDownController from '../Controller/useRandomSamplerDropDown.controller';
import {StyledFormControl, StyledInputLabel, StyledSelect, StyledMenuItem} from '../Style/RandomSamplerDropDown.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {IPropsView} from '../Config/RandomSamplerDropDown.types';


const RandomSamplerDropDownView = ({changeOption, title, checkBoxValue, label, options, checkIfDisable}: IPropsView) => {
    const {handleChange} = useRandomSamplerDropDownController(changeOption);

    return (
        <StyledFormControl>
            <StyledInputLabel>{title}</StyledInputLabel>
            <StyledSelect
                value={checkBoxValue ? checkBoxValue : 'None'}
                label={label}
                onChange={handleChange}
                MenuProps={{
                    PaperProps: {
                        style: {
                            backgroundColor: '#6b7280',
                        },
                    },
                }}
                renderValue={() => options[checkBoxValue]}
            >
                {Object.entries(options).map(([key, text]) => {
                    const isDisabled = checkIfDisable(key);

                    return isDisabled ? (
                        <BootstrapTooltip key={key} title={_SYSTEM_TITLES.dataSourceEmpty} placement='right'>
                            <Box>
                                <StyledMenuItem
                                    value={key}
                                    disabled
                                >
                                    {text}
                                </StyledMenuItem>
                            </Box>
                        </BootstrapTooltip>
                    ) : (
                        <StyledMenuItem key={key} value={key}>
                            {text}
                            {checkBoxValue === key && <CheckIcon/>}
                        </StyledMenuItem>
                    );
                })}
            </StyledSelect>
        </StyledFormControl>

    );
};

export default RandomSamplerDropDownView;
